
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_k2y2q_1at9v_3",
  "checkbox-control": "awsui_checkbox-control_k2y2q_1at9v_14",
  "input": "awsui_input_k2y2q_1at9v_22"
};
  